import { ActionReducer, INIT, UPDATE } from '@ngrx/store';

const SYNCED_KEYS = [
  'userObject',
  'studentObject',
  'otherClasses',
  'periodClassInfo',
  'assessment',
  'language',
  'multiAssessment'
];

export function localStorageSyncMetaReducer<T>(
  reducer: ActionReducer<T>
): ActionReducer<T> {
  return (state: T | undefined, action): T => {
    const nextState = reducer(state, action);

    if (typeof window !== 'undefined' && window.localStorage) {
      if (action.type === INIT || action.type === UPDATE) {
        const hydratedState: any = { ...nextState };
        SYNCED_KEYS.forEach(key => {
          const storedState = localStorage.getItem(key);
          if (storedState) {
            try {
              hydratedState[key] = JSON.parse(storedState);
            } catch (e) {
              console.error(`Error hydrating ${key}:`, e);
            }
          }
        });
        return hydratedState as T;
      }

      // Save each synced state to localStorage
      SYNCED_KEYS.forEach(key => {
        const slice = (nextState as any)[key];
        if (slice !== undefined) {
          localStorage.setItem(key, JSON.stringify(slice));
        }
      });
    }

    return nextState;
  };
}
